import React from 'react';
import { Modal } from 'app/shared/modal/modal';
import { Form, FormItem } from 'app/shared/form/form';
import { Button, Input } from 'antd';
import { CustomModal } from 'app/shared/customModal/customModal';
import s from './index.module.scss';

export const LendingImgModal = ({
    visible,
    onCancel,
    onFinish,
    initialValue,
}) => {
    return (
        <CustomModal
            destroyOnClose
            title={'Добавить изображение'}
            open={visible}
            onCancel={onCancel}
            className={s.img_modal}
            uniqueClass="lending-img-modal-uniqueClass"
        >
            <Form initialValues={{ img: initialValue }} onFinish={onFinish}>
                <FormItem
                    label="Ссылка на изображение"
                    name="img"
                    rules={[
                        {
                            required: true,
                            message: 'Введите изображение!',
                        },
                    ]}
                >
                    <Input />
                </FormItem>
                <FormItem>
                    <Button className={s.btn} type="primary" htmlType="submit">
                        Сохранить
                    </Button>
                </FormItem>
            </Form>
        </CustomModal>
    );
};
